import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from './firebase';
import { logEvent, setConsent } from 'firebase/analytics';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize consent mode v2 with Firebase
    setConsent(analytics, {
      'ad_storage': 'denied',
      'analytics_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied'
    });
  }, []);

  useEffect(() => {
    // Log page view events with Firebase Analytics
    if (analytics) {
      logEvent(analytics, 'page_view', {
        page_path: location.pathname,
        page_title: document.title
      });
    }
  }, [location]);

  return null;
};

export default GoogleAnalytics;